<template>
  <div id="page">
    <div class="container">
      <div class="row width_full mb_20">
        <div class="col_12">
          <div class="common_title">
            <h2>{{ form ? form.name : '' }}</h2>
          </div>
          <div class="row">
            <div class="col_6">
              <div :class="['form-group', {'has_error': errorFor('name')}]">
                <label>Name</label>
                <input type="text" class="form_global" placeholder="Page Title" v-model="form.name" @keyup="keyUpName()">
                <template v-if="errors && errors.name">
                  <small class="d_flex_start mb_5" v-for="(error, errorIndex) in errors.name" :key="'error_status_'+errorIndex">{{error}}</small>
                </template>
              </div>
            </div>
            <div class="col_6">
              <div :class="['form-group']">
                <label>Status</label>
                <select  class="form_global" v-model="form.status">
                  <option value="1">Active</option>
                  <option value="0">Inactive</option>
                </select>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col_12">
              <div :class="['form-group', {'has_error': errorFor('description')}]">
                <label>Description</label>
                <text-editor v-model:text="form['description']" :id="'description'" :height="500"></text-editor>
                <template v-if="errors && errors.description">
                  <small class="d_flex_start mb_5" v-for="(error, errorIndex) in errors.description" :key="'error_status_'+errorIndex">{{error}}</small>
                </template>
              </div>
            </div>
          </div>
          <div class="d_flex_end">
            <button class="btn btn_success" @click="submitForm()">Save</button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import TextEditor from "../../components/shared/TextEditor";
export default {
  name: "CustomPage",
  components: { TextEditor},
  data(){
    return {
      pages: [],
      form:{
        name: '',
        description: '',
        status: 1,
      },

    }
  },
  watch: {
    "$route.params.slug": {
      deep: true,
      handler() {
        this.loadPage()
      }
    },
  },
  created() {
    this.loadPage()
  },
  methods:{
    loadPage(){
      this.axios.get('/get-custom-pages/'+this.$route.params.slug)
          .then((response) => {
            this.form = response.data.data
          })
    },

    submitForm(){
      this.errors = null;
      this.loading = true;

        this.axios.post('/get-custom-pages/'+this.$route.params.slug, this.form)
            .then(() => {
              this.showSuccessMsg('Page Updated!')
            })
            .catch((err) => {
              this.errors = err.response.data.errors
            })
            .finally(() => {
              this.loading = false;
            })

    }
  }
}
</script>
